export const AvailabilityIntervalsFormat = 'HH:mm - HH:mm';
export const TimeFormat = 'HH:mm';
